import { composeValidators, selectRequired } from '../../utilities/validate'
import { useField } from 'react-final-form'
import { UseDatePickerProps } from './datepickerType'
import useTranslate from '../../i18n/useTranslate'

const useMyDatePicker = ({ name, required, validates = [] }: UseDatePickerProps) => {
    let mergeValidate = validates
    const translate = useTranslate()
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required?.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M016')}`),
            ...mergeValidate,
        ]
    }

    const field = useField<any>(name, { validate: composeValidators(...mergeValidate) })
    return { field }
}

export default useMyDatePicker
